'use strict';

angular.module('teams').controller('UserGroupsController',
	['$scope', '$stateParams', '$state', '$modal', '$location', 'Authentication', 'AvailableLanguages', 'UserGroups', 'Teams', 'TeamApps', 'TeamMembers', 'TeamLanguages', 'SubscriptionMain', 'Utilities', '$window',
		function ($scope, $stateParams, $state, $modal, $location, Authentication, AvailableLanguages, UserGroups, Teams, TeamApps, TeamMembers, TeamLanguages, SubscriptionMain, Utilities, $window) {
			$scope.authentication = Authentication;
			$scope.currentSubscription = {};
			$scope.isAdmin = false;
			$scope.roleInApp = null;

			$scope.availableLanguages = AvailableLanguages.get();
			$scope.teamLanguages = [];
			$scope.teamMembers = [];
			$scope.selectedLanguages = {};
			$scope.selectedMembers = {};
			$scope.userGroup = {
				name: null,
				team: $stateParams.teamId,
				user: $scope.authentication.user,
				members: {},
				languages: {}
			};
			$scope.roleDisplayNames = {
				'rejected': '#d7272f',
			    'accepted': '#008000',
				'reviewer': '#45880a',
				'translator': '#e3cc85'
			};

			if ($scope.authentication.user.username === 'superadmin' && $scope.authentication.user.email === 'superadmin@applanga.com') {
				$scope.isAdmin = true;
			}

			/**
			 * Returns the owner of the team from a list of team members
			 */
			$scope.getTeamOwner = function (userGroups) {
				for (var i = 0; i < userGroups.length; i++) {
					var userGroup = userGroups[i];
					if (userGroup.role === 'owner') {
						return userGroup.user;
					}
				}

				return undefined;
			};

			$scope.getCurrentRoleInApp = function () {
				var userId = $scope.authentication.user._id;
				for (var i = 0; i < $scope.teamMembers.length; i++) {
					if (userId === $scope.teamMembers[i].user._id) {
						$scope.roleInApp = $scope.teamMembers[i].role;
					}
				}
			};

			$scope.getFilteredTeamMembers = function(){
				switch ($scope.roleInApp) {
					case 'translator':
						return [];
					case 'manager':
						return $scope.teamMembers.filter(function(tm){ return tm.role === 'translator'; });
					default:
						return $scope.teamMembers;
				}
			};

			/**
			 * Returns if an additional team member can get added or not
			 */
			$scope.canUserAddUserGroups = function () {
				if ($scope.currentSubscription && $scope.currentSubscription.teamMembers && $scope.currentSubscription.usedTeamMembers) {
					if ($scope.currentSubscription.usedTeamMembers < $scope.currentSubscription.teamMembers) {
						return true;
					}
				}
				return false;
			};


			$scope.getUserGroupReadyToSave = function(){
				$scope.userGroup.members = $scope.teamMembers.filter(function (item) {
					return Object.keys($scope.selectedMembers).filter(function (memberKey) { return $scope.selectedMembers[memberKey] === true; }).includes(item._id);
				});
				$scope.userGroup.languages = $scope.teamLanguages.filter(function (item) { return $scope.selectedLanguages[item].selected === true; }).map(function (item) {
					return {
						roles: Object.keys($scope.selectedLanguages[item]).filter(function (languageKey) {
							return (languageKey !== 'selected' && $scope.selectedLanguages[item][languageKey] === true);
						}),
						language: item
					};
				});

				return new UserGroups($scope.userGroup);
			};


			// Create new User Group
			$scope.create = function () {

				// Before we send the data to the server we make sure that a role
				// got selected
				if (!$scope.userGroup.name) {
					$scope.error = 'Please select a name for the User Group.';
					return;
				}

				var userGroup = $scope.getUserGroupReadyToSave();

				// Redirect after save
				userGroup.$save({
					teamId: $stateParams.teamId
				}, function (response) {
					$location.path('teams/' + $stateParams.teamId);
				}, function (errorResponse) {

					if (errorResponse.data.upgradeRequired === true) {
						// User reached the subscription limit

						// Find the team owner to be able to display the correct modal
						$scope.findOneTeam(function (err, team) {
							if (err) {
								Utilities.showMessage(
									'Error!',
									'There was a problem finding the team owner. Please contact the support! Thanks!',
									'error'
								);
								return;
							}
						});
						return;
					}
					if (errorResponse.status !== 404) {
						// User does not exist
						$scope.error = errorResponse.data.message;
					} 
				});
			};

			// Remove existing Team
			$scope.remove = function () {
				UserGroups.remove({
					teamId: $stateParams.teamId,
					userGroupId: $stateParams.userGroupId
				}, function () {
					$location.path('teams/' + $stateParams.teamId);
				}, function (errorResponse) {
					$scope.error = errorResponse.data.message;
				});
			};

			// Update existing Team
			$scope.update = function () {
				// Before we send the data to the server we make sure that a role
				// got selected
				if (!$scope.userGroup.name) {
					$scope.error = 'Please select a name for the User Group.';
					return;
				}

				var userGroup = $scope.getUserGroupReadyToSave();

				userGroup.$update({
					teamId: $stateParams.teamId,
					userGroupId: $stateParams.userGroupId
				}, function () {
					$location.path('teams/' + $stateParams.teamId);
				}, function (errorResponse) {
					$scope.error = errorResponse.data.message;
				});
			};

			// Find existing Team
			$scope.findOneTeam = function (callback) {
				$scope.team = Teams.get({
					teamId: $stateParams.teamId
				}, function (response) {
					if (callback) {
						callback(null, response);
					}
				}, function (err) {
					if (callback) {
						callback(err);
					}
				});
			};

			$scope.findOneUserGroup = function(){
				UserGroups.get({
					teamId: $stateParams.teamId,
					userGroupId: $stateParams.userGroupId
				}, function(userGroup){
					$scope.userGroup = userGroup;
					for (var languageKey in userGroup.languages) {
						var userGroupLanguage = userGroup.languages[languageKey];
						var teamLanguage = $scope.teamLanguages.find(function(item){ return item === userGroupLanguage.language; });
						$scope.selectedLanguages[teamLanguage].selected = true;

						for (var rolKey in userGroupLanguage.roles) {
							var rol = userGroupLanguage.roles[rolKey];
							$scope.selectedLanguages[teamLanguage][rol] = true;
						}
					}

					for (var memberKey in userGroup.members) {
						var userGroupMember = userGroup.members[memberKey];
						var teamMember = $scope.teamMembers.find(function(item){ return item._id === userGroupMember._id; });
						$scope.selectedMembers[teamMember._id] = true;
					}
				});
			};

			// Find a list of Teams
			$scope.find = function () {
				$scope.teamId = $stateParams.teamId;
				
				async.parallel({
					getAllTeamLanguages: function(callback){
						$scope.getAllTeamLanguages(callback);
					},
					getAllTeamMembers: function(callback){
						$scope.getAllTeamMembers(callback);
					}
				}, function(err, result){
					if ($stateParams.userGroupId !== undefined) {
						$scope.findOneUserGroup();
					}
				});

				$scope.findOneTeam(function (err, teamInfo) {
					if (!err) {
						$scope.userGroups = teamInfo.userGroups;
						$scope.currentSubscription = teamInfo.planInfo;

						for (var gkey in $scope.userGroups) {
							for (var lkey in $scope.userGroups[gkey].languages) {
								var roles = $scope.userGroups[gkey].languages[lkey].roles;
								$scope.userGroups[gkey].languages[lkey].roles = $scope.getEvenRolesGroups(roles);
							}
						}
					}
				});
			};

			// Inits selected languages
			$scope.initSelectedLanguages = function(teamLanguages){
				for (var languageKey in teamLanguages) {
					var language = teamLanguages[languageKey];
					$scope.selectedLanguages[language] = { selected: false, roles: Object.keys($scope.roleDisplayNames) };
				}
			};

			// Get all the languages the team has
			$scope.getAllTeamLanguages = function(callback){
				if(!$scope.teamLanguages || !$scope.teamLanguages.length){
					TeamLanguages.get({
						teamId: $scope.teamId
					}, function (teamLanguages) {
						$scope.teamLanguages = teamLanguages[0].names;
						$scope.initSelectedLanguages($scope.teamLanguages);

						return callback();
					});
				} else {
					$scope.initSelectedLanguages($scope.teamLanguages);

					return callback();
				}
			};

			// Get all the members the team has
			$scope.getAllTeamMembers = function(callback){
				TeamMembers.getAll({
					teamId: $scope.teamId
				}, function (teamMembers) {
					$scope.teamMembers = teamMembers;
					$scope.getCurrentRoleInApp();

					for (var memberKey in teamMembers) {
						var member = teamMembers[memberKey];
						$scope.selectedMembers[member._id] = false;
					}

					return callback();
				});
			};

			// Find existing Team
			$scope.findOne = function () {
				$scope.findOneTeam();
				$scope.teamId = $stateParams.teamId;

				async.parallel({
					getAllTeamLanguages: function(callback){
						$scope.getAllTeamLanguages(callback);
					},
					getAllTeamMembers: function(callback){
						$scope.getAllTeamMembers(callback);
					}
				}, function(err, result){
					if ($stateParams.userGroupId !== undefined) {
						$scope.findOneUserGroup();
					}
				});
			};

			// Updates selected language when clicking on iso area
			$scope.toggleLanguageIntoStatus = function (name) {
				$scope.selectedLanguages[name].selected = !$scope.selectedLanguages[name].selected;

				if(!$scope.selectedLanguages[name].selected){
					Object.keys($scope.selectedLanguages[name]).forEach(function(key){
						$scope.selectedLanguages[name][key] = false;
					});
				} else {
					$scope.selectedLanguages[name].translator = true;
				}
			};

			// Updates selected member when clicking on iso area
			$scope.toggleMemberIntoStatus = function (id) {
				$scope.selectedMembers[id] = !$scope.selectedMembers[id];
			};

			// Checks if when selecting a role the language is also selected
			$scope.selectParentLanguage = function (name) {
				$scope.selectedLanguages[name].selected = true;
			};

			// Gets Language full Name
			$scope.getLanguageName = function(name){
				var language = $scope.teamLanguages.find(function(item){ return item === name; });

				if(language){
					return language;
				}
			};

			// Gets selected language roles in a group of 2 by 2 items
			// so that ic can be displayed correctly on Team details view
			$scope.getEvenRolesGroups = function(roles){
				var evenRolesGroup = {}, counter = 0;
			
				for (var index = 0; index < roles.length; index++) {
					if(index === 0 || index % 2 === 0){
						if(roles[index]){
							if(roles[index+1]){
								evenRolesGroup[counter++] = [roles[index], roles[index+1]];
							} else {
								evenRolesGroup[counter++] = [roles[index]];
							}
						}
					}
				}
				
				return evenRolesGroup;
			};

			// Gets the specific role color for the given role
			$scope.getRoleColor = function(role){
				return $scope.roleDisplayNames[role];
			};
		}
	]);
